import { jsx as _jsx } from "preact/jsx-runtime";
import { ConfirmationModal } from '@/components/modals/ConfirmationModal';
export function WebSignOffModal({ isOpen, onClose, onConfirm, loading, hasIntegration }) {
    const message = hasIntegration
        ? "Signing off will sync this web's online event details and speakers to BigMarker. This action confirms the web is ready."
        : "This action confirms the web is ready.";
    return (_jsx(ConfirmationModal, { isOpen: isOpen, title: "Sign Off Web", message: message, type: "info", confirmText: "Sign Off", onConfirm: onConfirm, onCancel: onClose, loading: loading }));
}
